var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sign-and-download-btn focus_bg-black-a15 focus_outline-none rounded-full",on:{"click":_vm.signAndDownload}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }